import http from "../../http-common";
/* eslint-disable */
class McuService {
  mcuList(page, itemPerPage, keyword) {
    return http.get(
      "/mcu/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("nama_en", data.nama_en);
    bodyFormData.append("phone", data.phone);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);
    if (data.icon_url != null) bodyFormData.append("icon", data.icon_url);

    return http.post("/mcu", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("nama_en", data.nama_en);
    bodyFormData.append("phone", data.phone);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);
    if (data.icon_url != null) bodyFormData.append("icon", data.icon_url);

    return http.put(`/mcu/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/mcu/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new McuService();
